(function() {
    'use strict';
    
    angular
        .module('sideApp')
        .controller('EvaluacionController', EvaluacionController);

    EvaluacionController.$inject = ['$scope', '$state', 'CuestionarioAlumnoService', 'ParseLinks', 'AlertService','NivelEducativoService'];

    function EvaluacionController ($scope, $state, CuestionarioAlumnoService, ParseLinks, AlertService,NivelEducativoService) {
    	var vm = this;
    	vm.show = 0;
    	vm.save = save;
		vm.resuelto = null;
		vm.validarPreguntayRespuestaDependiente = validarPreguntayRespuestaDependiente;
		vm.resetearResDePregDepediente = resetearResDePregDepediente;
		vm.deshabilitar = deshabilitar;
		vm.tipo = tipo;
    	vm.anterior = anterior;
    	vm.siguiente = siguiente;
    	vm.validarseccion = validarseccion;
		vm.validarCheck = validarCheck;
    	vm.valido = false;
		vm.validoCheck = false;
    	vm.mensaje = null;
		vm.mensajeCheck = null;
    	vm.preguntainvalida = [];
		vm.preguntainvalidaCheck = [];
    	vm.contain = contain;
    	vm.tiponivel = getNivelByPlan();
		vm.nivel = $state.params.nivPlan;
    	vm.idins = $state.params.idins;
		vm.msjCargando=true;
		vm.menu=menu;
		vm.modelo = $state.params.modPlan;
		
		loadCuestionario();
				
		function loadCuestionario(){
			CuestionarioAlumnoService.obtener({
			    		ambito : $state.params.ambito
			        }, onSuccess, onError); 
		} 
		
		function onSuccess(data, headers) {
			vm.msjCargando=true; 
		    vm.resuelto = data;
			
		}

		function onError(error) {  
			vm.msjCargando=false;         
			AlertService.error(error.data.message);
		}
        
        function getNivelByPlan(){
        	return NivelEducativoService.getNivelByPlanAlumno({
        		nivPlan : $state.params.nivPlan
            }, onSuccessNiv, onErrorNiv);
        }

		function onSuccessNiv(data, headers) {
		vm.tiponivel = data;
		}

		function onErrorNiv(error) {      
		AlertService.error(error.data.message);
		}
		
		function menu(){
			$state.go("docente");
		}
				
        function save() {
        	var grupo = vm.resuelto.grupoPreguntasForUI;
        	var cuestionario = vm.resuelto.cuestionarioResuelto;

			vm.validarseccion(grupo.length-1);
			vm.validarCheck(grupo.length-1);
			
			if(vm.valido && vm.validoCheck){
				for(var i = 0; i < grupo.length; i++){
				    for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
				    	for(var h = 0;h < cuestionario.respuestasPregunta.length; h++){
				    		if(cuestionario.respuestasPregunta[h].pregunta.id == grupo[i].preguntasWrapperForUI[j].pregunta.id){
				    			if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'RadioButton'){
				    				cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
				    			}
				    			if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'TextArea'){
				    				cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
				    			}
				    			if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'Escala'){
				    				cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
				    			}
								if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'){
								    cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
								}
				    		}
				    	}
				    }
				}
				CuestionarioAlumnoService.save(cuestionario, onSaveSuccess, onSaveError);
			}
			
        }
		
		function resetearResDePregDepediente(preguntaId){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador !=null && 
						grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador.id==preguntaId){
						// Inicio metodo recursivo	
						resetearResDePregDepediente(grupo[i].preguntasWrapperForUI[j].pregunta.id);
						// Fin metodo recursivo		
						grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada=null;
					}
				}
			}

		}
		
		function validarPreguntayRespuestaDependiente(idPregActivador,respuestaStringActivador,tipoPregunta){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			var aux = false;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador ){ 		
						if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador){
							if(tipoPregunta == 'CheckBox'){
								var boolVar = Boolean(respuestaStringActivador);
								if(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == boolVar){
									aux=true;
									break;	
								}
							}else{
								if(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == respuestaStringActivador){
									aux=true;
									break;	
								}
							}
								
						}
					}		
				}
			}
			return aux;      	
		}
		
		function deshabilitar(preguntaid,preguntaActivador,opcionpreguntaactivador){
			var boolVar = true;
			if( (preguntaActivador == null && opcionpreguntaactivador == null) ||
				(   
					preguntaActivador != null && opcionpreguntaactivador != null &&
					vm.validarPreguntayRespuestaDependiente(preguntaActivador.id,opcionpreguntaactivador.respuestaString,preguntaActivador.tipoPregunta.tipoPregunta)
				) ){
					boolVar = false;
				}
			return boolVar;
		}
        
		function tipo(tipo){
			return typeof tipo;
		}
		
        function onSaveSuccess(result) {
            $scope.$emit('sideApp:usuarioUpdate', result);
            $state.go('alumno',{}, {reload: true});
        }
        
        function onSaveError(error) {
            AlertService.error(error.data.message);
            $state.go('alumno',{}, {reload: true});
        }
        
        function anterior(indice){
       		vm.show = indice;
       		vm.mensaje = null;
			vm.mensajeCheck = null;
       		vm.valido = null;
			vm.validoCheck = null;
        }
        function siguiente(indice){
        	vm.validarseccion(indice);
			vm.validarCheck(indice);
        	if(vm.valido && vm.validoCheck)
        		vm.show = indice+2;
        }
        
        function validarseccion(seccion){
        	var grupo = vm.resuelto.grupoPreguntasForUI;
        	var cuestionario = vm.resuelto.cuestionarioResuelto;
        	var valido = true;
        	var mensaje = null;
        	var k = 0;
        	vm.preguntainvalida = [];
        	var index =0;
        		for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
        			for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
        				if(grupo[seccion].preguntasWrapperForUI[j].pregunta.obligatoria && cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id){
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
									    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
								) ||
								(
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada != null &&
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'string' &&
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada.trim() == ''
								)
							){
        						valido = false;
        						vm.preguntainvalida[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
        						index++;
        					}
        				}
        			}
        		}
        		if(!valido){
        			mensaje="No has contestado todas las preguntas de esta sección.";
				}
        		vm.valido = valido;
        		vm.mensaje = mensaje;
        }
        
		function validarCheck(seccion){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var min = grupo[seccion].grupoPreguntas.min;
			var max = grupo[seccion].grupoPreguntas.max;
			vm.preguntainvalidaCheck = [];
			if(min != null){
				var aux = 0;
				var cuestionario = vm.resuelto.cuestionarioResuelto;
				var valido = false;
				var mensaje = null;
				var index =0;
				for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
					for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
						if(cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id &&
							grupo[seccion].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'
						){
							vm.preguntainvalidaCheck[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
							
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
								    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
							 	) 
//								No considerar a las preguntas string en un check
							){
								index++;
							}else{
								aux++;
							}
						}
					}
				}
				
				var tp = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.tipoPregunta.tipoPregunta;

				var idpa = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.id;

				var opa = grupo[seccion].preguntasWrapperForUI[0].pregunta.opcionpreguntaactivador.respuestaString;
				
				var auxVal = validarPreguntayRespuestaDependiente(idpa,opa,tp);
				
				if(aux>=min && aux<=max || !auxVal){
					vm.preguntainvalidaCheck = [];
					valido = true;
				}else{
					mensaje = "Selecciona mínimo "+min+" y máximo "+max+" elementos";
				}
				
				vm.validoCheck = valido;
				vm.mensajeCheck = mensaje;
			}else{
				vm.validoCheck = true;
			}
		}
				
        function contain(idpregunta){
        	var invalido = false;
			var index = 0;
        	for(index = 0;index < vm.preguntainvalida.length; index++){
        		if(vm.preguntainvalida[index] == idpregunta){
        			invalido = true;
        			break;
        		}
        	}
			if(!invalido){
				for(index = 0;index < vm.preguntainvalidaCheck.length; index++){
					if(vm.preguntainvalidaCheck[index] == idpregunta){
				    	invalido = true;
				        break;
				    }
				}
			}
        	return invalido;
        }
    }
})();
